import React from 'react';
import PropTypes from 'prop-types';
import './skeleton-row-loader.css';

const SkeletonRowLoader = ({ count, width, height }) => {
    return (
        <div className="rows-loading">
            {Array.from({ length: count }).map((_, index) => (
                <div
                    key={index}
                    className="box shine"
                    style={{ width: width, height: height }}
                ></div>
            ))}
        </div>
    );
};

SkeletonRowLoader.propTypes = {
    count: PropTypes.number.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
};

SkeletonRowLoader.defaultProps = {
    width: '100%',
    height: '20px',
};

export default SkeletonRowLoader;
